import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMenuItem, NbMenuService } from '@nebular/theme';
import { SubSink } from 'subsink';
import { AuthenticationService } from 'src/app/shared/service/authentication.service';
import { Router } from '@angular/router';
import { MenuItemScope } from 'src/app/shared/models/menu-item-scope.model';
import { UserService } from 'src/app/shared/service/user.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  sub = new SubSink();

  constructor(
    private menuService: NbMenuService,
    private authenticationService: AuthenticationService,
    private userService: UserService,
    private router: Router
  ) {
    this.sub.sink = menuService.onItemClick().subscribe(($event: any) => {
      if ($event.item.data === 'exit') {
        this.authenticationService.signOut();
        this.router.navigateByUrl('/sign-in');
      }
    });
  }

  menu: MenuItemScope[] = [];
  menuItems: MenuItemScope[] = [
    {
      title: 'لیست کاربران',
      link: '/dashboard/user',
      icon: {
        pack: 'font-awesome-light',
        icon: 'users'
      },
      scope: ['admin:view:users'],
      scopeAction: 'AND'
    },
    {
      title: 'ادمین',
      link: '/dashboard/admin',
      icon: {
        pack: 'font-awesome-light',
        icon: 'users-cog'
      },
      scope: ['admin:create:admin'],
      scopeAction: 'AND'
    },
    {
      title: 'تراکنش های کاربران',
      link: '/dashboard/transactions',
      icon: {
        pack: 'font-awesome-light',
        icon: 'exchange-alt'
      },
      scope: ['admin:view:user:transactions'],
      scopeAction: 'AND'
    },
    {
      title: 'مسدود سازی برداشت',
      link: '/dashboard/block-withdraw',
      icon: {
        pack: 'font-awesome-light',
        icon: 'ban'
      },
      scope: ['admin:view:withdraw-block-status',
        'admin:add:withdraw-block-status',
        'admin:delete:withdraw-block-status'],
      scopeAction: 'AND'
    },
    {
      title: 'سامانه جامع گزارش‌گیری',
      link: '/dashboard/report/general',
      icon: {
        pack: 'font-awesome-light',
        icon: 'file-chart-pie'
      }
    },
    {
      title: 'سفارشات بازار',
      link: '/dashboard/market-orders',
      icon: {
        pack: 'font-awesome-light',
        icon: 'receipt'
      },
      scope: ['admin:view:order'],
      scopeAction: 'AND'
    },
    {
      title: 'گزارش دارایی',
      icon: {
        pack: 'font-awesome-light',
        icon: 'file-alt'
      },
      scope: ['treasury:view:users:rial:withdraw', 'treasury:view:users:rial:deposits'],
      scopeAction: 'OR',
      children: [
        {
          title: ' واریز ریالی',
          link: '/dashboard/report/treasury/deposit',
          icon: {
            pack: 'font-awesome-regular',
            icon: 'wallet'
          },
          scope: ['treasury:view:users:rial:deposits'],
          scopeAction: 'AND'
        },
        {
          title: 'برداشت ریالی',
          link: '/dashboard/report/treasury/withdraw',
          icon: {
            pack: 'font-awesome-regular',
            icon: 'wallet'
          },
          scope: ['treasury:view:users:rial:withdraw'],
          scopeAction: 'AND'
        }
      ]
    },
    {
      title: 'حسابداری',
      id: 'rail-accounting',
      icon: {
        pack: 'font-awesome-light',
        icon: 'file-invoice'
      },
      scope: [
        'admin:view:user:crypto:withdraw',
        'admin:view:crypto:deposit',
        'admin:view:users:rial:withdraw',
        'admin:view:rial:deposit',
        'admin:view:wallet:transferv2',
        'admin:wallet:transfer'
      ],
      scopeAction: 'OR',
      children: [
        {
          title: 'انتقال وجه',
          link: '/dashboard/transfer',
          icon: {
            pack: 'font-awesome-light',
            icon: 'exchange-alt'
          },
          scope: ['admin:wallet:transfer', 'admin:view:wallet:transferv2'],
          scopeAction: 'OR'
        },
        // {
        //   title: 'مغایرت گیری جیبیت',
        //   link: '/dashboard/reconciliation',
        //   icon: {
        //     pack: 'font-awesome-regular',
        //     icon: 'dollar-sign'
        //   },
        //   scope: [],
        //   scopeAction: 'AND'
        // },
        {
          title: 'گزارش واریز ریالی',
          link: '/dashboard/report/deposit/rial',
          icon: {
            pack: 'font-awesome-regular',
            icon: 'dollar-sign'
          },
          scope: ['admin:view:rial:deposit'],
          scopeAction: 'AND'
        },
        {
          title: 'گزارش برداشت ریالی',
          link: '/dashboard/report/withdraw/rial',
          icon: {
            pack: 'font-awesome-regular',
            icon: 'dollar-sign'
          },
          scope: ['admin:view:users:rial:withdraw'],
          scopeAction: 'AND'
        },
        {
          title: 'گزارش واریز رمزارز',
          link: '/dashboard/report/deposit/crypto',
          icon: {
            pack: 'font-awesome-brand',
            icon: 'bitcoin'
          },
          scope: ['admin:view:crypto:deposit'],
          scopeAction: 'AND'
        },
        {
          title: 'گزارش برداشت رمزارز',
          link: '/dashboard/report/withdraw/crypto',
          icon: {
            pack: 'font-awesome-brand',
            icon: 'bitcoin'
          },
          scope: ['admin:view:user:crypto:withdraw'],
          scopeAction: 'AND'
        },
        {
          title: 'واریز دستی رمزارز',
          link: '/dashboard/report/manual-deposit',
          icon: {
            pack: 'font-awesome-light',
            icon: 'exchange-alt'
          },
          scope: ['admin:add:crypto_deposit'],
          scopeAction: 'AND'
        },
        {
          title: 'وام‌های نسواکس',
          link: '/dashboard/loan',
          icon: {
            pack: 'font-awesome-light',
            icon: 'university'
          },
          scope: ['admin:view:users:loans'],
          scopeAction: 'AND'
        }
      ]
    },
    {
      title: 'استخرمشارکت',
      id: 'partnership-pool',
      icon: {
        pack: 'font-awesome-light',
        icon: 'university'
      },
      link: '/dashboard/partnership-pool',
      scope: ['admin:view:pool-currencies', 'admin:edit:pool-currencies'],
      scopeAction: 'OR'
    },
    {
      title: 'مسترکارت',
      id: 'zeepay',
      icon: {
        pack: 'font-awesome-light',
        icon: 'credit-card'
      },
      scope: ['admin:view:zeepay:deposit', 'admin:view:zeepay:balance', 'admin:view:zeepay:manual-deposit'],
      scopeAction: 'OR',
      children: [
        {
          title: 'گزارش واریزهای ریالی',
          link: '/dashboard/zeepay/rial-deposits',
          icon: {
            pack: 'font-awesome-light',
            icon: 'list'
          },
          scope: ['admin:view:zeepay:deposit', 'admin:view:zeepay:balance'],
          scopeAction: 'AND'
        },
        {
          title: 'واریز برداشت دستی',
          link: '/dashboard/zeepay/manual-transfer',
          icon: {
            pack: 'font-awesome-light',
            icon: 'list'
          },
          scope: ['admin:view:zeepay:manual-deposit'],
          scopeAction: 'AND'
        }
      ]
    },
    {
      title: 'درخواست‌های برداشت',
      id: 'withdraw-requests',
      expanded: true,
      children: [
        {
          title: 'رمزارز',
          id: 'withdraw-request',
          link: '/dashboard/withdraw',
          icon: {
            pack: 'font-awesome-light',
            icon: 'file-invoice-dollar'
          },
          scope: ['admin:view:users:withdraw'],
          scopeAction: 'AND'
        },
        {
          title: 'ریالی',
          id: 'withdraw-request',
          link: '/dashboard/withdraw/rial',
          icon: {
            pack: 'font-awesome-light',
            icon: 'file-invoice-dollar'
          },
          scope: ['admin:view:users:withdraw'],
          scopeAction: 'AND'
        }
      ],
      icon: {
        pack: 'font-awesome-light',
        icon: 'file-invoice-dollar'
      },
      scope: ['admin:view:users:withdraw'],
      scopeAction: 'AND'
    },
    {
      title: 'ربات کاربران',
      id: 'withdraw-request',
      link: '/dashboard/robot',
      icon: {
        pack: 'font-awesome-light',
        icon: 'robot'
      },
      scope: ['admin:view:robot'],
      scopeAction: 'AND'
    },

    {
      title: 'دارایی‌ها',
      link: '/dashboard/asset',
      icon: {
        pack: 'font-awesome-light',
        icon: 'wallet'
      },
      scope: ['admin:view:wallets:summarize'],
      scopeAction: 'AND'
    },
    {
      title: 'کارمزدها',
      link: '/dashboard/fee',
      icon: {
        pack: 'font-awesome-light',
        icon: 'chart-line'
      },
      scope: ['admin:view:orders:fee'],
      scopeAction: 'AND'
    },
    {
      title: 'بارگذاری اعلانات',
      link: '/dashboard/sliders',
      icon: {
        pack: 'font-awesome-light',
        icon: 'upload'
      },
      scope: ['admin:view:banner']
    },
    {
      title: 'ارز‌ها',
      link: '/dashboard/currency',
      icon: {
        pack: 'font-awesome-brand',
        icon: 'bitcoin'
      },
      scope: ['admin:view:currency'],
      scopeAction: 'AND'
    },
    {
      title: 'لیست ارز جدید',
      link: '/dashboard/currency/prelist',
      scope: ['admin:view:prelist'],
      icon: {
        pack: 'font-awesome-brand',
        icon: 'bitcoin'
      },
      children: [
        {
          title: 'لیست ارز جدید',
          link: '/dashboard/currency/prelist/new',
          icon: {
            pack: 'font-awesome-brand',
            icon: 'bitcoin'
          }
        }, {
          title: 'مشاهده ارزها پیش لیست شده',
          link: '/dashboard/currency/prelist/edit',
          icon: {
            pack: 'font-awesome-brand',
            icon: 'bitcoin'
          }
        }
      ]
    },
    {
      title: 'صفحات سایت',
      link: '/dashboard/landing',
      icon: {
        pack: 'font-awesome-light',
        icon: 'file'
      },
      scope: [
        'admin:view:landing',
        'admin:create:landing',
        'admin:edit:landing',
        'admin:delete:landing'
      ],
      scopeAction: 'OR'
    },
    {
      title: 'پشتیبانی',
      icon: {
        pack: 'font-awesome-light',
        icon: 'users-cog'
      },
      children: [
        {
          title: 'احراز هویت',
          children: [
            {
              title: 'عکس سلفی',
              link: '/dashboard/identification/selfie-photo',
              icon: {
                pack: 'font-awesome-light',
                icon: 'portrait'
              },
              scope: ['admin:view:users:identity_photo_verification'],
              scopeAction: 'AND'
            }
          ],
          icon: {
            pack: 'font-awesome-light',
            icon: 'fingerprint'
          },
          scope: [
            'admin:view:users:personal_information_verification',
            'admin:view:users:identity_photo_verification',
            'admin:view:users:identity_photo_verification'
          ],
          scopeAction: 'OR'
        },
        {
          title: 'بازیابی دوعاملی',
          link: '/dashboard/support/totp',
          icon: {
            pack: 'font-awesome-light',
            icon: 'unlock'
          },
          scope: ['admin:view:support-requests'],
          scopeAction: 'AND'
        },
        {
          title: 'بازیابی واریزهای بدون ممو',
          link: '/dashboard/support/memo-recovery',
          icon: {
            pack: 'font-awesome-light',
            icon: 'unlock'
          },
          scope: ['admin:view:support-requests'],
          scopeAction: 'AND'
        }
      ]
    },
    {
      title: 'ورود و خروج',
      icon: {
        pack: 'font-awesome-light',
        icon: 'history'
      },
      children: [
        {
          title: 'ورود دو مرحله‌ای',
          link: '/dashboard/two-factor-authentication',
          icon: {
            pack: 'font-awesome-light',
            icon: 'shield-check'
          }
        },
        {
          title: 'شناسه های فعال',
          link: '/dashboard/sessions/active-session',
          icon: {
            pack: 'font-awesome-light',
            icon: 'cctv'
          }
        },
        {
          title: 'تاریخچه ورود و خروج',
          link: '/dashboard/sessions',
          icon: {
            pack: 'font-awesome-light',
            icon: 'exchange'
          }
        }
      ],
      scope: ['view:user:session'],
      scopeAction: 'AND'
    },
    {
      title: 'اطلاعیه عمومی',
      link: '/dashboard/notification',
      icon: {
        pack: 'font-awesome-light',
        icon: 'bell'
      },
      scope: ['admin:create:notification:all_users'],
      scopeAction: 'AND'
    },
    {
      title: 'خروج',
      icon: {
        pack: 'font-awesome-light',
        icon: 'sign-out'
      },
      data: 'exit'
    }
  ];

  generateMenu(items: MenuItemScope[]): MenuItemScope[] {
    const menu: MenuItemScope[] = [];
    for (const item of items) {
      if (this.authenticationService.checkScope(item.scopeAction ?? 'AND', ...(item.scope ?? []))) {
        if (item.children && item.children.length > 0) {
          item.children = this.generateMenu(item.children);
        }
        menu.push(item);
      }
    }
    return menu;
  }

  ngOnInit(): void {
    this.menu = this.generateMenu(this.menuItems);
    this.userService.withdrawRequest.subscribe((list) => {
      const withdrawRequestItem = this.menu.find(
        (item) => item.id === 'withdraw-requests'
      ) as MenuItemScope;
      if (
        withdrawRequestItem &&
        list.length > 0 &&
        withdrawRequestItem.children &&
        withdrawRequestItem.children.length > 0
      ) {
        withdrawRequestItem.children[0].badge = {
          status: 'danger',
          text: list.length.toString()
        };
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
